import { createContext, useContext } from "react";
import { User } from "../types/user.types";

interface UserOverviewContextType {
  user: User | null;
}

const UserOverviewContext = createContext<UserOverviewContextType | null>(null);

export const useUserOverview = () => {
  const context = useContext(UserOverviewContext);
  if (!context) {
    throw new Error("useUserOverview must be used within provider");
  }
  return context;
};

export default UserOverviewContext;
